export const NAVIGATION_DATA_ATTRIBUTE_IDS = {
  Advertising: 'Navigation.Advertising',
  AdsAnalytics: 'Navigation.AdvertisingAnalytics',
  Academy: 'Navigation.Academy',
  AddNewAmazonSellerAccount: 'Navigation.AddNewAmazonSellerAccount',
  AdminPanel: 'Navigation.AdminPanel',
  AmazonSellerAccounts: 'Navigation.AmazonSellerAccounts',
  Avatar: 'Navigation.Avatar',
  CategoryTrends: 'Navigation.CategoryTrends',
  HomeDashboard: 'Navigation.HomeDashboard',
  InventoryManager: 'Navigation.InventoryManager',
  Keywords: 'Navigation.Keywords',
  KeywordScout: 'Navigation.KeywordScout',
  KeywordLists: 'Navigation.KeywordLists',
  ListingBuilder: 'Navigation.ListingBuilder',
  ListingGrader: 'Navigation.ListingGrader',
  LogOut: 'Navigation.LogOut',
  ManageProducts: 'Navigation.ManageProducts',
  Marketing: 'Navigation.Marketing',
  MarketInsights: 'Navigation.MarketInsights',
  NicheHunter: 'Navigation.NicheHunter',
  OpportunityFinder: 'Navigation.OpportunityFinder',
  OtherTransactions: 'Navigation.OtherTransactions',
  PAndLStatement: 'Navigation.PAndLStatement',
  ProductResearch: 'Navigation.ProductResearch',
  ProductCosts: 'Navigation.ProductCosts',
  ProductDatabase: 'Navigation.ProductDatabase',
  ProductInsights: 'Navigation.ProductInsights',
  ProductSettings: 'Navigation.ProductSettings',
  ProfitOverview: 'Navigation.ProfitOverview',
  ProductTracker: 'Navigation.ProductTracker',
  Promotions: 'Navigation.Promotions',
  ReviewAutomation: 'Navigation.ReviewAutomation',
  RankTracker: 'Navigation.RankTracker',
  ReSyncMwsKeys: 'Navigation.ReSyncMwsKeys',
  ReviewAnalysis: 'Navigation.ReviewAnalysis',
  SalesAnalytics: 'Navigation.SalesAnalytics',
  SalesEstimator: 'Navigation.SalesEstimator',
  SegmentManager: 'Navigation.SegmentManager',
  Settings: 'Navigation.Settings',
  ShareAndTrends: 'Navigation.ShareAndTrends',
  ShareOfVoice: 'Navigation.ShareOfVoice',
  Suppliers: 'Navigation.Suppliers',
  SupplierDatabase: 'Navigation.SupplierDatabase',
  SupplierTracker: 'Navigation.SupplierTracker',
  TheExtension: 'Navigation.TheExtension',
  Toolbox: 'Navigation.Toolbox'
}
